import { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import { useGetCompayListQuery } from "../../../../store/api/companyapi";
import { useGetDoctypeCountQuery } from "../../../../store/api/globalapi";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling, pageSize } = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  //states used for deleting the record
      const [deleteDoc] = useDeleteDocMutation();
      const [delPopupVisible, setDelPopupVisible] = useState(false);
      const [delSelectedId, setDelSelectedId] = useState(null);
      const [delmessage, setDelmessage] = useState();
      const [alreadySubmitData, setAlreadySubmitData] = useState(false);
      const [delDone, setDelDone] = useState(false);
  const { data, isLoading, refetch:refetchCompanyData } = useGetCompayListQuery();
  // console.log("useGetCompany List",data);

  const { data: number_of_count, isLoading: count_loader , refetch:refetchCompanyCount } = useGetDoctypeCountQuery("Company");

  const brandList = data?.message || [];
  // console.log("useGetDoctypeCountQuery ",data);

  const filtersConfig = [
    { name: "siNo", label: "SI.No", width: "3.8%", type: 'number' },
    { name: "company_name", label: "Company Name", width: "25%", type: 'text' },
    { name: "country", label: "Country", width: "25%", type: 'text' },
    { name: "parent_company", label: "Parent Company", width: "25%", type: 'text' },
  ];

  let formattedCompanyData = [];
  if (Array.isArray(brandList?.values) && Array.isArray(brandList?.keys)) {
    formattedCompanyData = [...brandList.values].reverse().map((valueArr) => {
      return brandList.keys.reduce((acc, key, index) => {
        acc[key] = valueArr[index];
        return acc;
      }, {});
    });
  }
  console.log("formatted data", formattedCompanyData);

  // 🔍 Filtering logic
  const applyFilters = (data, filters) => {
    // ✅ Special case: siNo filter (index-based, ignore other filters)
    if (filters.siNo !== undefined && filters.siNo !== null && filters.siNo !== "") {
      const index = parseInt(filters.siNo, 10) - 1; // 1-based index
      if (index >= 0 && index < data.length) {
        return [data[index]];
      }
      return []; // if index is out of range
    }

    // ✅ Normal filtering logic
    return data.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const itemValue = item[key]?.toString().toLowerCase();
        const filterValue = value.toString().toLowerCase();
        return itemValue && itemValue.includes(filterValue);
      });
    });
  };

  const filteredData = applyFilters(formattedCompanyData, filters);
  const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  useEffect(() => {
      console.log('Effect triggered with pageSize:', pageSize);
      if (pageSize > 0) {
        refetchCompanyCount();
        refetchCompanyData();
      }
    }, [currentPage, filters, pageSize,screenHeight, screenScaling ]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);

    setCurrentPage(1); // reset to page 1 when filters change
  };

  const handleView = (id) => {
    try {
      navigate(`/master/company/view-Company`, { state: { companyid: id } });
    } catch (err) {
      console.error("View failed:", err);
    }
  };

  const handleEdit = async (id) => {
    try {
      navigate(`/master/company/edit-Company`, { state: { companyid: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };

const handleDelete = (id) => {
	setDelSelectedId(id);
	setDelPopupVisible(true);
	setAlreadySubmitData(false);
	setDelmessage("Are you sure you want to Delete this Company?");
};

const delHandleCancel = () => {
	setDelPopupVisible(false);
	setDelSelectedId(null);
};

const delHandleConfirm = async () => {
	try {
		await deleteDoc({
			doctype: "Company",
			name: delSelectedId,
		}).unwrap();
		setDelmessage(`Company ${delSelectedId} deleted successfully!`);
		setDelDone(true);
		setTimeout(() => {
			setDelPopupVisible(false);
			setDelSelectedId(null);
			setDelDone(false);
			refetchCompanyCount();
			refetchCompanyData();
		}, 1000);
	} catch (err) {
		console.error("Deletion Failed:", err);

		let errorMessage = "Failed to delete the Company!";

		//If the server is sending the error message , we will extract it.
		if (err?.data?._server_messages) {
			try {
				const messageArr = JSON.parse(err.data._server_messages);
				if (messageArr && messageArr.length > 0) {
					//parse inner json object
					const messageObj = JSON.parse(messageArr[0]);
					if (messageObj?.message) {
						//extract the exact message we want
						const fullMessage = messageObj.message;
						errorMessage = fullMessage.split("You must")[0].trim();
						//remove html in the message
						errorMessage = errorMessage.replace(/<[^>]+>/g, "");
					}
				}
			} catch (parseError) {
				console.error("Error parsing server messages:", parseError);
			}
		}
		setDelPopupVisible(true);
		setDelmessage(errorMessage);
		setAlreadySubmitData(true);
	} finally {
		// setTimeout(() => {
		//     setDelPopupVisible(false);
		//     setDelSelectedId(null);
		// }, 2000);
	}
};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      width: "7%",
      visible: true,
      cellRenderer: (row, index) => index + 1 + (currentPage - 1) * pageSize,
    },
    {
      header: "Company Name",
      name: "Company Name",
      accessor: "company_name",
      visible: true,
      width: "25%"
    },
    {
      header: "Country",
      name: "Country",
      accessor: "country",
      width: "25%",
      visible: true
    },
    {
      header: "Parent Company",
      name: "Parent Company",
      accessor: "parent_company",
      width: "25%",
      visible: true
    },
    {
      header: "Action",
      name: "Action",
      accessor: 'action',
      width: "0%",
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.company_name}
          onView={() => handleView(row.company_name)}
          onEdit={() => handleEdit(row.company_name)}
          onDelete={() => handleDelete(row.company_name)}
        />
      ),
    },
  ]);

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),

    },

    {
      className: "custom-btn-00989 d-flex",
      to: "/master/company/create-company",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Company"
    }
  ];
  const accessors = columnsConfig
    .filter(column => column.accessor !== "siNo" && column.accessor !=="action")
    .map(column => column.accessor);
  
  return (
    <div className="container-fluid d-flex flex-column" style={{ flexGrow: "1" }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "Company" },
          {
            label: "Company List",
            style: {
              borderBottom: "0px solid",
              textWrap: "nowrap",
              gap: "5px",
              color: "#270B79",
              fontSize: "",
            },
          },
        ]}
        actionButtons={actionButtons}
      >
        {
          showFilters && <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        }

        {showColumnConfig &&
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Company"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "action", "parent_company", "company_name"]}
          />}

        <Table columns={visibleColumns} data={paginatedData} loading={isLoading || count_loader} />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={filteredData.length}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (
          
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
        )}
        
        {showExportPopup && (
          <ExportCSV
            doctype="Company"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}

        <PopBox isOpen={isPopBoxOpen} onClose={() => setIsPopBoxOpen(false)} title="Select Company">
          <div className="selectbox">
            <p>Settings content goes here</p>
          </div>
        </PopBox>
      </ListLayout>
    </div>
  );
};

export default MainContent;
